<script scoped>
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formData: {
        kode_profesi: "",
        nama_profesi: "",
        id_dahan_profesi: null,
        id_mprofesi: null,
      },
      dahanProfesiOption: [],
    };
  },
  props: ["typeTrans", "dataProfesi"],
  watch: {
    dataProfesi: function (newVal) {
      if (newVal == null) {
        this.formData = {
          kode_profesi: "",
          nama_profesi: "",
          id_dahan_profesi: null,
          id_mprofesi: null,
        };
      } else {
        this.formData = {
          kode_profesi: newVal.kode_profesi,
          nama_profesi: newVal.nama_profesi,
          id_dahan_profesi: newVal.id_dahan_profesi,
          id_mprofesi: newVal.id_mprofesi,
        };
      }
    },
  },
  emits: ["submitForm"],
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let payload = { ...this.formData };
      const url =
        this.typeTrans == "add"
          ? "master/profesi"
          : `master/profesi/${this.formData.id_mprofesi}`;
      const method = this.typeTrans == "add" ? "post" : "put";
      const config = {
        method: method,
        url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
        },
      };
      await axios(config)
        .then((response) => {
          console.log({ response });
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            console.log({ result });
            Swal.close();
            this.$emit("submitForm");
          });
        })
        .catch((error) => {
          console.log({ error });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.data,
          });
        });
    },
    validateForm() {
      console.log(
        this.formData.kode_profesi === "" ||
          this.formData.nama_profesi === "" ||
          this.formData.id_dahan_profesi === null
      );
      if (
        this.formData.kode_profesi === "" ||
        this.formData.nama_profesi === "" ||
        !this.formData.id_dahan_profesi
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan Lengkapi Data",
        });

        return false;
      }

      return true; // Form is valid
    },
    async searchDahanProfesi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getDahanProfesi(search, loading);
      }
    },
    async getDahanProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/dahan-profesi/all",
          {
            params: {
              search: search,
              limit: 20,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.dahanProfesiOption = response.data.data;
          if (loading) loading(false);
        });
    },
  },
  mounted() {
    this.getDahanProfesi();
    this.filterDahanProfesi = _.debounce(
      this.searchDahanProfesi.bind(this),
      500
    );
  },
};
</script>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="form-group mb-3">
        <label for="kodeProfesi" class="form-label">Kode Profesi</label>
        <input
          type="text"
          v-model="formData.kode_profesi"
          class="form-control"
          id="kodeProfesi"
          placeholder="Kode Profesi..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="namaProfesi" class="form-label">Nama Profesi</label>
        <input
          type="text"
          v-model="formData.nama_profesi"
          class="form-control"
          id="namaProfesi"
          placeholder="Nama Profesi..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="Keterangan" class="form-label">Dahan Profesi</label>
        <v-select
          id="parent_menu"
          class="style-chooser"
          :options="dahanProfesiOption"
          :reduce="(item) => item.dp_id"
          label="dp_name"
          v-model="formData.id_dahan_profesi"
          placeholder="Dahan Profesi"
          @search="filterDahanProfesi"
        />
      </div>
      <div class="form-group float-end">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </div>
</template>
